"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _imageViewer = _interopRequireDefault(require("element-ui/packages/image/src/image-viewer"));
var _DetailCardDialog = _interopRequireDefault(require("./components/DetailCardDialog.vue"));
var _EditCardDialog = _interopRequireDefault(require("./components/EditCardDialog.vue"));
var _MakeCardDialog = _interopRequireDefault(require("./components/MakeCardDialog.vue"));
var _customerOrderPreApi = require("@/api/customerOrderPreApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomerOrderPre',
  components: {
    DetailCardDialog: _DetailCardDialog.default,
    EditCardDialog: _EditCardDialog.default,
    ElImageViewer: _imageViewer.default,
    MakeCardDialog: _MakeCardDialog.default
  },
  data: function data() {
    return {
      tableFrom: {
        page: 1,
        limit: 10,
        batchNo: '',
        cardFaceName: '',
        cardNo: '',
        status: '',
        availableProgram: '',
        createTimeStart: '',
        createTimeEnd: '',
        makeTimeStart: '',
        makeTimeEnd: ''
      },
      statusOptions: [{
        label: '待制作',
        value: 0
      }, {
        label: '已制作',
        value: 1
      }, {
        label: '生成中',
        value: 2
      }],
      programOptions: [],
      fuCardOptions: [],
      tableData: [],
      total: 0,
      listLoading: false,
      downloadTaskMap: {},
      downloadTaskTimers: {},
      imagePreviewVisible: false,
      imagePreviewList: [],
      imagePreviewBodyOverflow: ''
    };
  },
  computed: {
    createTimeRange: {
      get: function get() {
        return this.getTimeRange(this.tableFrom.createTimeStart, this.tableFrom.createTimeEnd);
      },
      set: function set(value) {
        this.setTimeRange(value, 'createTimeStart', 'createTimeEnd');
      }
    },
    makeTimeRange: {
      get: function get() {
        return this.getTimeRange(this.tableFrom.makeTimeStart, this.tableFrom.makeTimeEnd);
      },
      set: function set(value) {
        this.setTimeRange(value, 'makeTimeStart', 'makeTimeEnd');
      }
    }
  },
  created: function created() {
    this.getProgramOptions();
    this.getFuCardOptions();
    this.getList();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.imagePreviewVisible) {
      document.body.style.overflow = this.imagePreviewBodyOverflow;
    }
    this.clearAllDownloadTaskTimers();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _customerOrderPreApi.customerOrderPreListApi)(this.getListParams()).then(function (res) {
        var pageData = _this.normalizePageData(res);
        _this.tableData = pageData.list;
        _this.total = pageData.total;
      }).catch(function () {
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    getListParams: function getListParams() {
      return {
        page: this.tableFrom.page,
        limit: this.tableFrom.limit,
        batchNo: this.tableFrom.batchNo,
        cardFaceName: this.tableFrom.cardFaceName,
        cardNo: this.tableFrom.cardNo,
        status: this.tableFrom.status,
        availableProgram: this.tableFrom.availableProgram,
        createTimeStart: this.tableFrom.createTimeStart,
        createTimeEnd: this.tableFrom.createTimeEnd,
        makeTimeStart: this.tableFrom.makeTimeStart,
        makeTimeEnd: this.tableFrom.makeTimeEnd
      };
    },
    getTimeRange: function getTimeRange(startTime, endTime) {
      return startTime && endTime ? [startTime, endTime] : [];
    },
    setTimeRange: function setTimeRange(value, startKey, endKey) {
      var range = Array.isArray(value) ? value : [];
      this.tableFrom[startKey] = range[0] || '';
      this.tableFrom[endKey] = range[1] || '';
    },
    normalizePageData: function normalizePageData(res) {
      if (Array.isArray(res)) return {
        list: res,
        total: res.length
      };
      if (res && Array.isArray(res.list)) return {
        list: res.list,
        total: res.total || 0
      };
      if (res && Array.isArray(res.records)) return {
        list: res.records,
        total: res.total || 0
      };
      if (res && res.page && Array.isArray(res.page.list)) return {
        list: res.page.list,
        total: res.page.total || 0
      };
      return {
        list: [],
        total: 0
      };
    },
    getProgramOptions: function getProgramOptions() {
      var _this2 = this;
      (0, _customerOrderPreApi.customerProgramListApi)().then(function (res) {
        var list = _this2.normalizeCustomerList(res);
        _this2.programOptions = list.map(function (item) {
          return {
            id: item.id,
            appName: item.appName
          };
        }).filter(function (item) {
          return item.id !== undefined && item.id !== null && item.appName;
        });
      });
    },
    getFuCardOptions: function getFuCardOptions() {
      var _this3 = this;
      (0, _customerOrderPreApi.customerOrderPreFuCardListApi)({
        keyword: '',
        isCombo: false
      }).then(function (res) {
        var list = _this3.normalizeCustomerList(res);
        _this3.fuCardOptions = list.map(function (item) {
          return {
            id: item.id,
            cardName: item.card_name || item.cardName
          };
        }).filter(function (item) {
          return item.id !== undefined && item.id !== null && item.cardName;
        });
      });
    },
    normalizeCustomerList: function normalizeCustomerList(res) {
      if (Array.isArray(res)) return res;
      if (res && Array.isArray(res.list)) return res.list;
      if (res && Array.isArray(res.records)) return res.records;
      if (res && res.page && Array.isArray(res.page.list)) return res.page.list;
      return [];
    },
    handleSearch: function handleSearch() {
      this.tableFrom.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.tableFrom = {
        page: 1,
        limit: 10,
        batchNo: '',
        cardFaceName: '',
        cardNo: '',
        status: '',
        availableProgram: '',
        createTimeStart: '',
        createTimeEnd: '',
        makeTimeStart: '',
        makeTimeEnd: ''
      };
      this.getList();
    },
    handleMakeCard: function handleMakeCard() {
      this.$refs.MakeCardDialogRef.open();
    },
    handleMakeCardSubmit: function handleMakeCardSubmit(params) {
      console.log('制卡参数', params);
      this.getList();
    },
    handleDetail: function handleDetail(row) {
      this.$refs.DetailCardDialogRef.open(row);
    },
    handleEdit: function handleEdit(row) {
      this.$refs.EditCardDialogRef.open(row);
    },
    handleEditSubmit: function handleEditSubmit() {
      this.getList();
    },
    handleMake: function handleMake(row) {
      var _this4 = this;
      this.$confirm("\u662F\u5426\u786E\u8BA4\u5C06\u3010".concat(row.batchNo, "\u3011\u6539\u4E3A\u5DF2\u5236\u5361\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return (0, _customerOrderPreApi.customerOrderPreConfirmMakeApi)({
          id: row.id
        });
      }).then(function () {
        _this4.$message.success('操作成功');
        _this4.getList();
      }).catch(function () {});
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;
      if (Number(row.status) !== 0) {
        this.$message.warning('只有待制作状态可以删除');
        return;
      }
      var params = {
        id: row.id,
        batchNo: row.batchNo,
        cardNoRange: row.cardNoRange,
        status: row.status
      };
      if (!params.id || !params.batchNo) {
        this.$message.warning('缺少删除预制卡所需参数');
        return;
      }
      this.$confirm("\u786E\u5B9A\u5220\u9664\u3010".concat(row.batchNo, "\u3011\u5417\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\u3002"), '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return (0, _customerOrderPreApi.customerOrderPreDeleteApi)(params);
      }).then(function () {
        _this5.$message.success('删除成功');
        if (_this5.tableData.length === 1 && _this5.tableFrom.page > 1) {
          _this5.tableFrom.page -= 1;
        }
        _this5.getList();
      }).catch(function () {});
    },
    handleDownload: function handleDownload(row) {
      var _this6 = this;
      var availableProgram = row.availableProgram === undefined || row.availableProgram === null ? '' : String(row.availableProgram).trim();
      var appId = Number(availableProgram);
      var params = {
        id: row.id,
        batchNo: row.batchNo,
        cardNoRange: row.cardNoRange,
        appId: appId
      };
      if (!params.id || !params.batchNo || !params.cardNoRange || !availableProgram || Number.isNaN(appId)) {
        this.$message.warning('缺少下载预制卡所需参数');
        return;
      }
      if (this.isDownloadTaskRunning(row)) return;
      this.$set(this.downloadTaskMap, row.id, {
        status: 'CREATING',
        progress: 0,
        queuePosition: 0
      });
      (0, _customerOrderPreApi.customerOrderPreDownloadApi)(params).then(function (res) {
        var taskInfo = _this6.normalizeDownloadTaskResponse(res);
        var taskId = taskInfo.taskId || taskInfo.id;
        if (!taskId) {
          _this6.$message.warning('未获取到导出任务ID');
          _this6.clearDownloadTask(row.id);
          return;
        }
        _this6.$set(_this6.downloadTaskMap, row.id, {
          taskId: taskId,
          status: taskInfo.inQueue ? 'WAITING' : 'PENDING',
          queuePosition: taskInfo.queuePosition || 0,
          progress: 0
        });
        _this6.$message.info(taskInfo.message || (taskInfo.inQueue ? '任务已创建，排队中' : '任务已创建，正在导出中'));
        _this6.pollDownloadTask(row.id, taskId);
      }).catch(function () {
        _this6.clearDownloadTask(row.id);
      });
    },
    normalizeDownloadTaskResponse: function normalizeDownloadTaskResponse(res) {
      return res && res.data ? res.data : res || {};
    },
    isDownloadTaskRunning: function isDownloadTaskRunning(row) {
      var task = this.downloadTaskMap[row.id];
      return !!task && ['CREATING', 'PENDING', 'WAITING', 'PROCESSING'].includes(task.status);
    },
    getDownloadButtonText: function getDownloadButtonText(row) {
      var task = this.downloadTaskMap[row.id];
      if (!task) return '下载预制卡';
      if (task.status === 'CREATING') return '创建中';
      if (task.status === 'WAITING') {
        return task.queuePosition ? "\u6392\u961F\u4E2D(".concat(task.queuePosition, ")") : '排队中';
      }
      if (task.status === 'PENDING') return '等待处理';
      if (task.status === 'PROCESSING') {
        return task.progress ? "\u5BFC\u51FA\u4E2D".concat(task.progress, "%") : '导出中';
      }
      return '下载预制卡';
    },
    pollDownloadTask: function pollDownloadTask(rowId, taskId) {
      var _this7 = this;
      this.clearDownloadTaskTimer(rowId);
      var requestTaskStatus = function requestTaskStatus() {
        (0, _customerOrderPreApi.customerOrderPreDownloadTaskApi)(taskId).then(function (res) {
          var task = _this7.normalizeDownloadTaskResponse(res);
          var status = task.status;
          _this7.$set(_this7.downloadTaskMap, rowId, {
            taskId: taskId,
            status: status,
            progress: task.progress || 0,
            queuePosition: task.queuePosition || 0
          });
          if (status === 'COMPLETED') {
            _this7.clearDownloadTaskTimer(rowId);
            if (task.downloadUrl) {
              window.open(task.downloadUrl);
              _this7.$message.success('导出完成');
            } else {
              _this7.$message.warning('导出完成，但未获取到下载链接');
            }
            _this7.clearDownloadTask(rowId);
            return;
          }
          if (status === 'FAILED') {
            _this7.clearDownloadTaskTimer(rowId);
            _this7.$message.error(task.errorMessage || '导出失败');
            _this7.clearDownloadTask(rowId);
            return;
          }
          if (status === 'CANCELLED') {
            _this7.clearDownloadTaskTimer(rowId);
            _this7.$message.warning('任务已中止');
            _this7.clearDownloadTask(rowId);
          }
        }).catch(function () {
          _this7.clearDownloadTaskTimer(rowId);
          _this7.clearDownloadTask(rowId);
        });
      };
      requestTaskStatus();
      var timer = setInterval(requestTaskStatus, 2500);
      this.$set(this.downloadTaskTimers, rowId, timer);
    },
    clearDownloadTaskTimer: function clearDownloadTaskTimer(rowId) {
      var timer = this.downloadTaskTimers[rowId];
      if (timer) {
        clearInterval(timer);
        this.$delete(this.downloadTaskTimers, rowId);
      }
    },
    clearDownloadTask: function clearDownloadTask(rowId) {
      this.clearDownloadTaskTimer(rowId);
      this.$delete(this.downloadTaskMap, rowId);
    },
    clearAllDownloadTaskTimers: function clearAllDownloadTaskTimers() {
      var _this8 = this;
      Object.keys(this.downloadTaskTimers).forEach(function (rowId) {
        _this8.clearDownloadTaskTimer(rowId);
      });
    },
    openImagePreview: function openImagePreview(url) {
      if (!url) return;
      this.imagePreviewBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.imagePreviewList = [url];
      this.imagePreviewVisible = true;
    },
    closeImagePreview: function closeImagePreview() {
      document.body.style.overflow = this.imagePreviewBodyOverflow;
      this.imagePreviewList = [];
      this.imagePreviewVisible = false;
    },
    getStatusText: function getStatusText(status) {
      var statusMap = {
        0: '待制作',
        1: '已制作',
        2: '生成中'
      };
      return statusMap[status] || status;
    },
    getStatusClass: function getStatusClass(status) {
      var classMap = {
        0: 'status-wait',
        1: 'status-done',
        2: 'status-making'
      };
      return classMap[status] || '';
    },
    getAvailableCount: function getAvailableCount(row) {
      if (row.canUseTotal !== undefined && row.canUseTotal !== null) return row.canUseTotal;
      if (!row.cardNoStart || !row.cardNoEnd) return 0;
      return row.cardNoEnd - row.cardNoStart + 1;
    },
    getProgramNames: function getProgramNames(row) {
      var _this9 = this;
      var ids = this.getProgramIds(row);
      if (!ids.length) return row.availableProgram || '--';
      var names = ids.map(function (id) {
        var program = _this9.programOptions.find(function (item) {
          return String(item.id) === String(id);
        });
        return program ? program.appName : '';
      }).filter(Boolean);
      return names.length ? names.join('、') : row.availableProgram || '--';
    },
    getProgramIds: function getProgramIds(row) {
      if (Array.isArray(row.availableProgramIds)) return row.availableProgramIds;
      if (typeof row.availableProgram === 'number') return [row.availableProgram];
      if (typeof row.availableProgram === 'string') {
        return row.availableProgram.split(',').map(function (item) {
          return item.trim();
        }).filter(Boolean);
      }
      return [];
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.tableFrom.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.tableFrom.page = val;
      this.getList();
    }
  }
};